import { dataMember, required } from 'santee-dcts';
import { AudienceRoleName } from './../authentication/audience-role';

export class UserMetadata {
    @dataMember()
    @required()
    public userId: number;

    @dataMember()
    @required()
    public sitelinkUserId: string;

    @dataMember()
    @required()
    public fullName: string;

    @dataMember({ customDeserializer: (value: string): AudienceRoleName => value as AudienceRoleName })
    @required({ nullable: true })
    public audienceRole: AudienceRoleName;

    @dataMember()
    @required({ nullable: true })
    public originalUserFullName: string;

    @dataMember()
    @required({ nullable: true })
    public email: string;
}